// client\src\utils\authutils.js

import { jwtDecode } from 'jwt-decode'; // Corrected import

/**
 * Checks if the JWT token in localStorage is valid
 * @returns {boolean} True if token exists and is not expired
 */
export const isTokenValid = () => {
  const token = localStorage.getItem('token');
  if (!token) {
    console.log('No token found in localStorage');
    return false;
  }

  try {
    // Validate token format before decoding
    if (!token.includes('.') || token.split('.').length !== 3) {
      console.error('Invalid token format');
      localStorage.removeItem('token'); // Clear invalid token
      return false;
    }

    const decodedToken = jwtDecode(token);
    const currentTime = Date.now() / 1000; // Current time in seconds
    
    // Check if token has expiration and is still valid
    if (!decodedToken.exp) {
      console.error('Token missing expiration');
      return false;
    }
    
    if (decodedToken.exp < currentTime) {
      console.log('Token expired');
      localStorage.removeItem('token'); // Clear expired token
      return false;
    }
    
    return true;
  } catch (error) {
    console.error("Error decoding token:", error);
    localStorage.removeItem('token'); // Clear invalid token
    return false;
  }
};

/**
 * Checks if the current route is a public route that doesn't require authentication
 * @returns {boolean} True if the current route is public
 */
const isPublicRoute = () => {
  const publicRoutes = ['/login', '/register', '/create-account', '/verify-email', '/forgot-password', '/reset-password', '/setup', '/about', '/download', '/docs'];
  return publicRoutes.some(route => window.location.pathname.startsWith(route));
};

/**
 * Checks authentication status and redirects to login if not authenticated
 * @returns {boolean} True if user is authenticated
 */
export const checkAuthAndRedirect = () => {
  const isAuthenticated = isTokenValid();
  
  if (!isAuthenticated && !isPublicRoute()) {
    console.log('User not authenticated, redirecting to login');
    // Store the current URL to redirect back after login
    localStorage.setItem('redirectAfterLogin', window.location.pathname + window.location.search);
    window.location.href = '/login';
    return false;
  }
  
  return isAuthenticated;
};

// Set up an interval to check token validity periodically
const setupTokenCheck = () => {
  // Check token validity every 30 seconds
  setInterval(() => {
    if (!isPublicRoute() && !isTokenValid()) {
      console.log('Token check: Not valid, redirecting to login');
      localStorage.setItem('redirectAfterLogin', window.location.pathname + window.location.search);
      window.location.href = '/login';
    }
  }, 30000); // 30 seconds
};

// Initialize the token check when the utils are imported
if (typeof window !== 'undefined') {
  setupTokenCheck();
}